import { render, staticRenderFns } from "./TemplatesView.vue?vue&type=template&id=cf7386b0&"
import script from "./TemplatesView.vue?vue&type=script&lang=js&"
export * from "./TemplatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports